var _defs, _path, _g, _path2, _text, _g2, _path3, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRi1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 441.656,
    height: 109.9,
    viewBox: "0 0 441.656 109.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 35.871,
    height: 35.871,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1318",
    "data-name": "Rectangle 1318",
    width: 82.578,
    height: 82.576,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322",
    transform: "translate(-834.922 -2583.335)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M523.846,10.082H779.629a54.95,54.95,0,0,1,54.949,54.949v0a54.95,54.95,0,0,1-54.949,54.949H523.846A22.383,22.383,0,0,1,506.71,112L474.747,73.975a13.9,13.9,0,0,1,0-17.885L506.71,18.063a22.383,22.383,0,0,1,17.135-7.981",
    transform: "translate(384.619 2573.253)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(834.922 2621.222)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M458.6,51.064a17.936,17.936,0,1,0,17.936-17.936A17.936,17.936,0,0,0,458.6,51.064",
    transform: "translate(-458.601 -33.128)",
    fill: "#ff8206"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M464.663,47.16a7.971,7.971,0,1,0,7.97-7.97,7.97,7.97,0,0,0-7.97,7.97",
    transform: "translate(380.225 2591.997)",
    fill: "#fff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Improves_Procurement_Supply_Chain_operations",
    "data-name": "Improves Procurement  Supply Chain operations",
    transform: "translate(912 2635)",
    fontSize: 20,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Improves Procurement "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "Supply Chain operations"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    transform: "translate(1194 2596)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M677.276,59.193a41.289,41.289,0,1,0,41.288-41.288,41.288,41.288,0,0,0-41.288,41.288",
    transform: "translate(-677.276 -17.905)",
    fill: "#ff8206"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M686.22,53.433A26.585,26.585,0,1,0,712.8,26.849,26.584,26.584,0,0,0,686.22,53.433",
    transform: "translate(522.78 2584.151)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1310",
    "data-name": "Group 1310",
    transform: "translate(-3152.8 -948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309",
    transform: "translate(4374.8 3570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M29.88,15.6a3.6,3.6,0,0,1-.761-1.3L24.9,16.742a3.6,3.6,0,0,1,.761,1.3Z",
    transform: "translate(-19.476 -10.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M14.622,47.185V42.3a3.088,3.088,0,0,1-.761.063A6.159,6.159,0,0,1,13.1,42.3v4.885a3.088,3.088,0,0,1,.761-.063A2.069,2.069,0,0,1,14.622,47.185Z",
    transform: "translate(-11.419 -29.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M82.1,42.3v4.885a3.088,3.088,0,0,1,.761-.063,6.159,6.159,0,0,1,.761.063V42.3a6.159,6.159,0,0,1-.761.063A3.089,3.089,0,0,1,82.1,42.3Z",
    transform: "translate(-58.534 -29.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M24.9,75.3l4.218,2.442a3.8,3.8,0,0,1,.761-1.3L25.661,74A4.127,4.127,0,0,1,24.9,75.3Z",
    transform: "translate(-19.476 -51.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M59.4,76.442a4.127,4.127,0,0,1,.761,1.3L64.38,75.3a4.127,4.127,0,0,1-.761-1.3Z",
    transform: "translate(-43.034 -51.322)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M59.3,15.6l4.25,2.442a3.358,3.358,0,0,1,.761-1.3L60.061,14.3A3.6,3.6,0,0,1,59.3,15.6Z",
    transform: "translate(-42.965 -10.557)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M44.742,82.2a2.442,2.442,0,1,0,2.442,2.442A2.443,2.443,0,0,0,44.742,82.2Z",
    transform: "translate(-31.357 -56.921)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 2.442,
    cy: 2.442,
    r: 2.442,
    transform: "translate(10.943 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M79.242,27.285A2.442,2.442,0,1,0,76.8,24.842,2.443,2.443,0,0,0,79.242,27.285Z",
    transform: "translate(-54.915 -16.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M10.242,22.4a2.442,2.442,0,1,0,2.442,2.442A2.443,2.443,0,0,0,10.242,22.4Z",
    transform: "translate(-7.8 -16.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M79.242,62.2a2.442,2.442,0,1,0,2.442,2.442A2.443,2.443,0,0,0,79.242,62.2Z",
    transform: "translate(-54.915 -43.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M10.242,62.2a2.442,2.442,0,1,0,2.442,2.442A2.443,2.443,0,0,0,10.242,62.2Z",
    transform: "translate(-7.8 -43.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M31.6,29.677l5.836,3.108,5.836-3.108L37.436,26.6Z",
    transform: "translate(-24.051 -18.956)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M58.3,47.346V40.4l-5.9,3.108v6.978Z",
    transform: "translate(-38.254 -28.379)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M29,47.346l5.9,3.14V43.508L29,40.4Z",
    transform: "translate(-22.276 -28.379)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi1);
export default __webpack_public_path__ + "static/media/ri1.f4ff0355d0371d4ce0a021de0cb9e1a6.svg";
export { ForwardRef as ReactComponent };